import React, { useState } from 'react';

import ListAltIcon from '@mui/icons-material/ListAlt';
import { Alert, Button, Stack } from '@mui/material';

import ErrorDisplay from '~/components/Common/ErrorDisplay';
import { SettingsForm } from '~/components/SupportAssistant/components/SettingsForm';
import SettingsHistoryModal from '~/components/SupportAssistant/components/SettingsHistoryModal';

import { ROLE_LESA_ADMIN } from '~/consts/roles';

import { useGetSettings } from '~/hooks/apis/support/useSettings';
import useCurrentUser from '~/hooks/useCurrentUser';

import { DEFAULT_SETTINGS } from './settings';

export default function SettingsPageContent() {
  const [error, setError] = useState<Error | null>(null);
  const [showSettingsHistory, setShowSettingsHistory] = useState(false);

  const { user } = useCurrentUser();
  const hasAccess = Boolean(user?.roles.includes(ROLE_LESA_ADMIN));
  const settingsQuery = useGetSettings({ enabled: hasAccess });
  const settings = settingsQuery.data
    ? {
        ...DEFAULT_SETTINGS,
        ...settingsQuery.data.settings?.values,
      }
    : null;

  if (!hasAccess) {
    return (
      <Stack direction="column" alignItems="center" spacing={2}>
        <ErrorDisplay message="You are not allowed to view this page" />
      </Stack>
    );
  }

  return (
    <>
      <Stack direction="column" alignItems="center" spacing={2}>
        {settingsQuery.isError && settingsQuery.error instanceof Error && (
          <ErrorDisplay message={settingsQuery.error.message} />
        )}
        {error && <ErrorDisplay message={error.message} />}
      </Stack>

      {settingsQuery.isSuccess && !error && settings && (
        <>
          {!settingsQuery.data.settingsEnabled && (
            <Stack direction="column" alignItems="center" spacing={2}>
              <Alert severity="warning">
                Settings disabled as a feature in support service, any change you make here won't make any difference
                until the feature is enabled.
              </Alert>
            </Stack>
          )}
          <SettingsForm settings={settings} onError={setError} />

          <Button startIcon={<ListAltIcon />} color="success" onClick={() => setShowSettingsHistory(true)}>
            History
          </Button>
          <SettingsHistoryModal open={showSettingsHistory} onClose={() => setShowSettingsHistory(false)} />
        </>
      )}
    </>
  );
}
